module.exports = __webpack_public_path__ + "static/img/jp1-2.3b724ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/jp1-2.png
// module id = 913
// module chunks = 0